import { createAction } from "@coverme/redux";
import { stringify } from "@coverme/querystring";
import Axios from "axios";

export const getPdfList = (assistanceCategories, encounterId, customerId, asOf, jurisdictions = ["MS"]) => {
    const queryStringObj = {
        jurisdictions: jurisdictions,
        assistanceCategory: assistanceCategories || [],
        asOf: asOf,
        encounterId: encounterId,
    };

    const queryString = stringify(queryStringObj);
    return createAction("GET_PDF_LIST", () =>
        Axios.get(`/api/pdf/customers/${customerId}/form-keys?${queryString}`).then(data => data.data)
    );
};

export const getAllPdfsForCustomer = (customerId, jurisdictions) => {
    const queryStringObj = {
        jurisdictions: jurisdictions,
        includeAllAssistanceCategories: true,
    };

    const queryString = stringify(queryStringObj);
    return createAction("GET_PDF_LIST", () =>
        Axios.get(`/api/pdf/customers/${customerId}/form-keys?${queryString}`).then(data => data.data)
    );
};

export const getAllPdfsForGivenCustomerId = (customerId, jurisdictions, encounterId = null) => {
    const queryStringObj = {
        jurisdictions: jurisdictions,
        includeAllAssistanceCategories: true,
        encounterId: encounterId,
    };

    const queryString = stringify(queryStringObj);

    return createAction("GET_PDF_LIST_FOR_CUST_CODE", () =>
        Axios.get("/api/pdf/customers/" + customerId + `/form-keys?${queryString}`).then(data => data.data.mergedList)
    );
};

export const resetPdfs = () => createAction("RESET_PDFS", {});